import { render, staticRenderFns } from "./MediaOwnersScreensListItem.vue?vue&type=template&id=2698f5ce&"
import script from "./MediaOwnersScreensListItem.vue?vue&type=script&lang=js&"
export * from "./MediaOwnersScreensListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports